<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：服务类型列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="swatchHousekeepingType({ hktId: '', hktName: '全部' })"
              :class="{ 'selected': housekeepingServInfo.conditions.hktId === '' }">
              全部
            </li>
            <li v-for="(item, index) in housekeepingServInfo.housekeepingTypes" :key="index"
              @click="swatchHousekeepingType(item)"
              :class="{ 'selected': housekeepingServInfo.conditions.hktId == item.hktId }">
              {{ item.hktName }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和家政服务列表 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input
                v-model="housekeepingServInfo.conditions.servName"
                placeholder="请输入服务名称"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="housekeepingServInfo.conditions.repairWay"
                placeholder="请选择派单方式"
                style="width:200px"
                clearable
              >
                <el-option
                  v-for="item in housekeepingServInfo.repairWays"
                  :key="item.statusCd"
                  :label="item.name"
                  :value="item.statusCd"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryHousekeepingServMethod" icon="el-icon-search">
                查询
              </el-button>
              <el-button type="primary" @click="_resetHousekeepingServMethod" icon="el-icon-refresh">
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 家政服务列表 -->
        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>家政服务</span>
            <div>
              <el-button type="primary" @click="_openAddHousekeepingServModal" icon="el-icon-plus">
                添加
              </el-button>
              <el-button type="primary" @click="_openAddHousekeepingFeeConfigRel('', '')" icon="el-icon-plus">
                创建费用
              </el-button>
            </div>
          </div>
          <el-table
            :data="housekeepingServInfo.housekeepingServs"
            style="width: 100%"
            border
            stripe
            v-loading="loading"
          >
          <el-table-column prop="servId" label="服务编号" align="center" />
          <el-table-column prop="servName" label="服务名称" align="center" />
          <el-table-column prop="servDesc" label="服务描述" align="center" />
          <el-table-column prop="hktName" label="服务类型" align="center" />
          <el-table-column label="派单方式" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.repairWay === '100'">抢单</span>
              <span v-else-if="scope.row.repairWay === '200'">指派</span>
              <span v-else-if="scope.row.repairWay === '300'">轮训</span>
            </template>
          </el-table-column>
          <el-table-column label="回访方式" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.returnVisitFlag === '001'">都不回访</span>
              <span v-else-if="scope.row.returnVisitFlag === '002'">已评价不回访</span>
              <span v-else-if="scope.row.returnVisitFlag === '003'">都回访</span>
            </template>
          </el-table-column>
          <el-table-column prop="sales" label="销量" align="center" />
          <el-table-column prop="defaultFee" label="默认费用" align="center" />
          <el-table-column prop="sort" label="排序" align="center" />
          <el-table-column label="上架状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.state === '1001' ? '未上架' : '上架' }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" />
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openEditHousekeepingServModel(scope.row)">修改</el-button>
              <el-button size="mini" type="danger" @click="_openDeleteHousekeepingServModel(scope.row)">删除</el-button>
              <el-button size="mini" @click="_viewServDetail(scope.row)">查看</el-button>
              <el-button size="mini" @click="_openHousekeepingFeeConfigManageRel(scope.row)">查看费用</el-button>
              <el-button size="mini" @click="_openHousekeepingServUser(scope.row)">维修师傅</el-button>
            </template>
          </el-table-column>
        </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="housekeepingServInfo.conditions.page"
            :page-size="housekeepingServInfo.conditions.row"
            layout="total, prev, pager, next"
            :total="housekeepingServInfo.total"
            style="margin-top: 20px; text-align: right;"
          />
        </el-card>
      </el-col>
    </el-row>

    <delete-housekeeping-serv ref="deleteHousekeepingServ"></delete-housekeeping-serv>
    <add-housekeeping-fee-config-rel ref="addHousekeepingFeeConfigRel"></add-housekeeping-fee-config-rel>
    <view-qrcode ref="viewQrcode"></view-qrcode>
  </div>
</template>

<script>
import { queryHousekeepingServ } from '@/api/housekeeping/housekeepingServApi'
import { getHousekeepingTypes } from '@/api/housekeeping/housekeepingApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import viewQrcode from '@/components/system/viewQrcode'

export default {
  name: 'HousekeepingServ',
  components: {
    'delete-housekeeping-serv': () => import('@/components/housekeeping/deleteHousekeepingServ'),
    'add-housekeeping-fee-config-rel': () => import('@/components/housekeeping/addHousekeepingFeeConfigRel'),
    viewQrcode
  },
  data() {
    return {
      loading: false,
      housekeepingServInfo: {
        housekeepingServs: [],
        total: 0,
        records: 1,
        moreCondition: false,
        servId: '',
        componentShow: 'housekeepingServ',
        housekeepingTypes: [],
        repairWays: [],
        conditions: {
          repairWay: '',
          servName: '',
          hktId: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      this.housekeepingServInfo.conditions.shopId = getShopId()
      this._listHousekeepingServs()
      this._listHousekeepingTypes()
      try {
        const {data} = await getDict('housekeeping_serv', 'repair_way')
        this.housekeepingServInfo.repairWays = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listHousekeepingServs() {
      this.loading = true
      try {
        const res = await queryHousekeepingServ(this.housekeepingServInfo.conditions)
        this.housekeepingServInfo.total = res.total || 0
        this.housekeepingServInfo.records = res.records || 1
        this.housekeepingServInfo.housekeepingServs = res.data || []
      } catch (error) {
        console.error('请求失败处理', error)
      } finally {
        this.loading = false
      }
    },
    async _listHousekeepingTypes() {
      try {
        const res = await getHousekeepingTypes({
          page: 1,
          row: 50,
          typeCd: 1001,
          shopId: getShopId()
        })
        this.housekeepingServInfo.housekeepingTypes = res.data || []
      } catch (error) {
        console.error('获取服务类型失败:', error)
      }
    },
    swatchHousekeepingType(type) {
      this.housekeepingServInfo.conditions.hktId = type.hktId
      this.housekeepingServInfo.conditions.page = 1
      this._listHousekeepingServs()
    },
    _openAddHousekeepingServModal() {
      this.$router.push('/pages/housekeeping/addHousekeepingServ')
    },
    _openEditHousekeepingServModel(housekeepingServ) {
      this.$router.push(`/pages/housekeeping/editHousekeepingServ?servId=${housekeepingServ.servId}`)
    },
    _openDeleteHousekeepingServModel(housekeepingServ) {
      this.$refs.deleteHousekeepingServ.open(housekeepingServ)
    },
    _queryHousekeepingServMethod() {
      this.housekeepingServInfo.conditions.page = 1
      this._listHousekeepingServs()
    },
    _resetHousekeepingServMethod() {
      this.housekeepingServInfo.conditions = {
        repairWay: '',
        servName: '',
        hktId: '',
        shopId: getShopId(),
        page: 1,
        row: 10
      }
      this._listHousekeepingServs()
    },
    _openAddHousekeepingFeeConfigRel(servId, servName) {
      this.$refs.addHousekeepingFeeConfigRel.open({ _servId: servId, _servName: servName })
    },
    _openHousekeepingFeeConfigManageRel(housekeepingServ) {
      this.$router.push(`/pages/housekeeping/housekeepingServFeeConfigManageRel?servId=${housekeepingServ.servId}&servName=${housekeepingServ.servName}`)
    },
    _openHousekeepingServUser(housekeepingServ) {
      this.$router.push(`/pages/housekeeping/housekeepingServUserManage?servId=${housekeepingServ.servId}&servName=${housekeepingServ.servName}`)
    },
    _viewServDetail(serv) {
      console.log(serv)
      this.$refs.viewQrcode.open({
        qrcodeName: serv.servName,
        qrCodeUrl: serv.pageUrl,
        remark: '手机扫码查看家政服务'
      })
    },
    handleCurrentChange(val) {
      this.housekeepingServInfo.conditions.page = val
      this._listHousekeepingServs()
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>